import { useState, useCallback, useMemo } from 'react';

export const useZoneFilters = (zones: any[]) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProvider, setSelectedProvider] = useState<string>('all');
  const [showProviderFilter, setShowProviderFilter] = useState(false);

  const handleToggleProviderFilter = useCallback(() => {
    setShowProviderFilter((prev) => !prev);
  }, []);

  const handleClearFilters = useCallback(() => {
    setSearchTerm('');
    setSelectedProvider('all');
  }, []);

  const filteredZones = useMemo(() => {
    return zones.filter((zone) => {
      const matchesSearch = !searchTerm || 
        zone.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        zone.providerName.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesProvider = selectedProvider === 'all' || zone.providerId === selectedProvider;
      return matchesSearch && matchesProvider;
    });
  }, [zones, searchTerm, selectedProvider]);

  const isFiltered = searchTerm !== '' || selectedProvider !== 'all';

  return {
    searchTerm,
    setSearchTerm,
    selectedProvider,
    setSelectedProvider,
    showProviderFilter,
    handleToggleProviderFilter,
    handleClearFilters,
    filteredZones,
    isFiltered,
  };
};